// extracted by mini-css-extract-plugin
export default {"ZoomBg":"Drag_ZoomBg__015hu","ZoomSlider":"Drag_ZoomSlider__cqkrW"};